/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {useIntl} from 'react-intl'
// import Select from 'react-select';

import {Table} from 'src/feature/bite/component/Table'
import {useProvider} from '../../hook'

const MemberDetailAddress = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detailTab, detailTabSet} = useProvider()

  const [list, setList] = useState(-1)

  const contents = detailTab?.Address?.dataList
  const content = detailTab?.Address?.dataList[list]

  const paging = detailTab?.Address?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'addressLine',
      dataIndex: 'addressLine',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.ADDRESS_LINE'}),
    },
    {
      key: 'buildingNo',
      dataIndex: 'buildingNo',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.BUILDING_NO'}),
    },
    {
      key: 'country',
      dataIndex: 'country',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.COUNTRY'}),
    },
    {
      key: 'city',
      dataIndex: 'city',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.CITY'}),
    },
    {
      key: 'region',
      dataIndex: 'region',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.REGION'}),
    },
    {
      key: 'zipCode',
      dataIndex: 'zipCode',
      title: intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.ZIP_CODE'}),
    },
    {
      key: 'detailURL',
      dataIndex: 'id',
      title: '',
      render: (text: string, _, index) => (
        <a onClick={() => setList(index)} style={{cursor: 'pointer'}}>
          {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.DETAIL'})}
        </a>
      ),
    },
  ]

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <h3 className='fw-bold m-0'>{intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS'})}</h3>
        </div>
        {list !== -1 && (
          <div className='card-title m-0'>
            <a onClick={() => setList(-1)}>
              <i className='bi bi-arrow-left me-2'></i>
              {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.BACK_TO_LIST'})}
            </a>
          </div>
        )}
      </div>

      {list === -1 ? (
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={false}
              dataSource={contents}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!detailTab || !detailTab.Address) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== detailTab.Address.paging.pageSize ? 1 : current

                  detailTabSet({
                    ...detailTab,
                    Address: {
                      ...detailTab.Address,
                      paging: {
                        ...paging,
                        currentPageNumber: currentPage,
                        pageSize: pageSize,
                      },
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      ) : (
        <>
          {content && (
            <div className='card-body p-9'>
              <div className='row'>
                <div className='col'>
                  <div className='column mb-7'>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.ADDRESS_LINE'})}
                    </label>

                    <div className='col-lg-12 fv-row'>
                      <span className='fw-semibold text-gray-800 fs-6'>{content.addressLine}</span>
                    </div>
                  </div>

                  <div className='column mb-7'>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.BUILDING_NO'})}
                    </label>

                    <div className='col-lg-12'>
                      <span className='fw-semibold text-gray-800 fs-6'>{content.buildingNo}</span>
                    </div>
                  </div>
                  <div className='column mb-7'>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.ZIP_CODE'})}
                    </label>

                    <div className='col-lg-4 mt-2'>
                      <span className='fw-semibold text-gray-800 fs-6'>{content.zipCode}</span>
                    </div>
                  </div>
                </div>
                <div className='col'>
                  <div className='column mb-7'>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.COUNTRY'})}
                    </label>

                    <div className='col-lg-4 mt-2'>
                      <span className='fw-semibold text-gray-800 fs-6'>{content?.country}</span>
                    </div>
                  </div>

                  <div className='column mb-7'>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.CITY'})}
                    </label>

                    <div className='col-lg-4 mt-2'>
                      <span className='fw-semibold text-gray-800 fs-6'>{content?.city}</span>
                    </div>
                  </div>

                  <div className='column mb-7'>
                    <label className='col-lg-4 fw-semibold text-muted'>
                      {intl.formatMessage({id: 'MEMBER.DETAIL.ADDRESS.REGION'})}
                    </label>

                    <div className='col-lg-4 mt-2'>
                      <span className='fw-semibold text-gray-800 fs-6'>{content?.region}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default MemberDetailAddress
